import React from 'react';
import { useSelector } from 'react-redux';
import TextInfo, {
  KIND_TEXT,
  COLOR,
  ALIGN,
  SIZE,
  FONT_TYPE,
} from '@bit/gerenciatd.unifiedcomponents.text-info';
import CustomLink from '@bit/gerenciatd.unifiedcomponents.custom-link';
import { CUSTOM_LINK_CONTENT } from '@bit/gerenciatd.utils.tagging';
import SvgIconLoader from '@bit/gerenciatd.unifiedicons.svg-icon-loader';
import SvgIconLabel, {
  SVGICON_LABEL_POSITION,
  SVG_ICON_KIND,
  ICONS_ID,
} from '@bit/gerenciatd.unifiedicons.svg-icon-label';
import DeviceContent from './DeviceContent';
import { useSelectedProductOfGroup } from '../../../../hooks/useSelectedProductOfGroup';
import { COMPONENT_NAME } from '../../index';
import './ConfiguratorContent.scss';

export const ConfiguratorContent = ({
  title,
  content,
  enlace,
  taggingInfo,
  devicesInfo,
}) => {
  const { productHired: groupProductsHired } = useSelector(
    state => state.fusion
  );
  const { selectedProduct } = useSelectedProductOfGroup(groupProductsHired);
  const { hiredProductR2rPrice } = useSelector(state => state.fusion);
  const { hiredProductR2rPriceAditional } = useSelector(
    state => state.fusion
  );

  if (!selectedProduct) {
    return null;
  }

  const componentProduct = `${selectedProduct.product.name};${selectedProduct.product.taxonomy}`;
  const deviceInfoPrice = (deviceInfo, innerTitle) => {
    let includedSmartphoneprice = '';
    if (innerTitle === 'DISPOSITIVO INCLUIDO') {
      if (
        deviceInfo.productId
        && hiredProductR2rPrice
        && hiredProductR2rPrice[deviceInfo.productId]
        && hiredProductR2rPrice[deviceInfo.productId].texts
      ) {
        includedSmartphoneprice = hiredProductR2rPrice[
          deviceInfo.productId
        ].texts.find((element) => {
          if (element.typeId === '20') {
            return element;
          }
          return null;
        });
      }
      return includedSmartphoneprice ? includedSmartphoneprice.text : '';
    }
    if (innerTitle === 'DISPOSITIVO ADICIONAL') {
      let aditionalSmartphoneProce = '';
      if (
        deviceInfo.productId
        && hiredProductR2rPriceAditional
        && hiredProductR2rPriceAditional[deviceInfo.productId]
        && hiredProductR2rPriceAditional[deviceInfo.productId].texts
      ) {
        aditionalSmartphoneProce = hiredProductR2rPriceAditional[
          deviceInfo.productId
        ].texts.find((element) => {
          if (element.typeId === '20') {
            return element;
          }
          return null;
        });
      }
      return aditionalSmartphoneProce ? aditionalSmartphoneProce.text : '';
    }
  };
  return (
    <div className="ConfiguratorContent__wrapper border">
      <TextInfo
        className="ConfiguratorContent__text"
        text={title}
        kind={KIND_TEXT.PARAGRAPH}
        align={ALIGN.LEFT}
        color={COLOR.GREY_6}
        size={SIZE.TITLE6}
        fontType={FONT_TYPE.REGULAR}
      />
      {devicesInfo
        && devicesInfo.map((deviceInfo) => {
          return (
            <DeviceContent
              deviceInfo={{
                ...deviceInfo,
                precio: deviceInfoPrice(deviceInfo, title),
              }}
            />
          );
        })}
      <TextInfo
        className="ConfiguratorContent__text"
        text={content}
        kind={KIND_TEXT.PARAGRAPH}
        align={ALIGN.LEFT}
        color={COLOR.GREY_4}
        size={SIZE.CAPTION1}
        fontType={FONT_TYPE.REGULAR}
      />
      {enlace && (
        <div className="ConfiguratorContent__enlace">
          <CustomLink
            link={enlace.link}
            taggingInfo={{
              ...taggingInfo,
              componentName: COMPONENT_NAME,
              componentContent: CUSTOM_LINK_CONTENT.DEFAULT,
              componentProduct: { componentProduct },
            }}
          >
            <span>
              <SvgIconLabel
                id={ICONS_ID.Cheuron}
                iconSize={12}
                labelSize={18}
                SvgIconLoader={SvgIconLoader}
                label={enlace.text}
                labelColor={COLOR.BLUE}
                labelPosition={SVGICON_LABEL_POSITION.LEFT}
                kind={SVG_ICON_KIND.MEDIUM}
                iconColor={COLOR.BLUE}
              />
            </span>
          </CustomLink>
        </div>
      )}
    </div>
  );
};
